export enum Vote {
  positive = 'pos',
  negative = 'neg',
}

export class PostVote {
  post: number
  voter: number
  vote: Vote

  constructor(post: number, voter: number, vote: Vote) {
    this.post = post
    this.voter = voter
    this.vote = vote
  }
}
